import { ModalFooter, Prompt } from '@ingka/modal';
import { Button, ModalWrapper } from 'list/DesignSystem';
import translate from 'list/utils/translate';
import { h } from 'preact';

type InspirationsRemovedModalProps = {
    destroy: () => void;
    quantity: number;
};

const InspirationsRemovedModal = ({ destroy, quantity }: InspirationsRemovedModalProps) => {
    const title =
        quantity > 1
            ? translate('UNAVAILABLE_INSPIRATIONS_REMOVED_MULTIPLE title')
            : translate('UNAVAILABLE_INSPIRATIONS_REMOVED title');
    const body =
        quantity > 1
            ? translate('UNAVAILABLE_INSPIRATIONS_REMOVED_MULTIPLE details', { count: quantity.toString() })
            : translate('UNAVAILABLE_INSPIRATIONS_REMOVED details');
    return (
        <ModalWrapper visible={true} handleCloseBtn={destroy}>
            <Prompt
                title={title}
                footer={
                    <ModalFooter>
                        <Button key="close" type="primary" text={translate('modal_close')} onClick={destroy} />
                    </ModalFooter>
                }
            >
                <p>{body}</p>
            </Prompt>
        </ModalWrapper>
    );
};

export default InspirationsRemovedModal;
